import React from 'react'
import { useAuth } from '../context/AuthContext'
import { authService } from '../services/authService'
import styled from 'styled-components'
import ResponsiveLayout from '../components/ResponsiveLayout'

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`

const LoginCard = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
`

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 1rem;
`

const Description = styled.p`
  color: #6b7280;
  margin-bottom: 2rem;
  line-height: 1.6;
`

const LoginButton = styled.button`
  width: 100%;
  padding: 1rem 2rem;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`

const ErrorMessage = styled.div`
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
`

function Login() {
  const { login } = useAuth()
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState('')

  const handleLogin = async () => {
    setLoading(true)
    setError('')
    
    try {
      console.log('🚀 Starting Microsoft login...')
      
      // Get the login URL from backend
      const loginUrl = await authService.getLoginUrl()
      console.log('🔗 Redirecting to:', loginUrl)
      
      // Redirect to Microsoft OAuth
      window.location.href = loginUrl
      
    } catch (error) {
      console.error('❌ Login failed:', error)
      setError(error.response?.data?.detail || error.message || 'Login failed. Please try again.')
      setLoading(false)
    }
  }

  return (
    <ResponsiveLayout>
      <LoginContainer>
        <LoginCard>
          <Title>Academic Inbox AI</Title>
          <Description>
            Sign in with your Microsoft account to access your academic email assistant.
            Manage your student communications efficiently with AI-powered responses.
          </Description>
          
          {error && (
            <ErrorMessage>
              {error}
            </ErrorMessage>
          )}
          
          <LoginButton 
            onClick={handleLogin} 
            disabled={loading}
          >
            {loading ? 'Redirecting...' : 'Sign in with Microsoft'}
          </LoginButton>
          
          <div style={{ marginTop: '2rem', fontSize: '0.875rem', color: '#6b7280' }}>
            <p>You'll be redirected to Microsoft to sign in securely.</p>
          </div>
        </LoginCard>
      </LoginContainer>
    </ResponsiveLayout>
  )
}

export default Login
